import { createFileRoute } from "@tanstack/react-router";
import { InicioPage } from "@/paginas/inicio";

export const Route = createFileRoute("/_authenticated/inicio")({
  head: () => ({
    meta: [
      { title: "Início — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Tela inicial do Milky Moo Palmares com acesso rápido às principais áreas do sistema.",
      },
      { property: "og:title", content: "Início — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Tela inicial do Milky Moo Palmares com acesso rápido às principais áreas do sistema.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: InicioPage,
});
